import { ApiHelper } from './api.helper';
import { IPreInscriptionReason } from '../types/pre-inscription-reason.type';
import { HttpUtils } from '../utils/http.utils';
import { IFilters, IRequestParams } from '../views/PreInscriptionsReasons/types';

export const fetchPreInscriptionsReasons = async (
  filters: IFilters,
): Promise<IPreInscriptionReason[]> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('pre-inscriptions/reasons')}?${queryParams}`;
  const response = await fetch(url, ApiHelper.makeOptions());
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const downloadPreInscriptionsReasons = async (filters: IFilters): Promise<Blob> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('pre-inscriptions/reasons/export')}?${queryParams}`;

  const response = await fetch(url, ApiHelper.makeOptions());
  const data = response.blob();

  if (!response.ok) {
    const responseData = await response.json();

    throw new Error(await responseData.message);
  }

  return data;
};
